/* src/app/features/modalidade_garantia/modal-outras-garantias/modal-outras-garantias.component.scss */
.alert {
  margin-top: 1em !important;
}
/*# sourceMappingURL=modal-outras-garantias.component.css.map */
